import { Actions } from '../../interfaces'
import { ResponsibleAgreement } from '@/entities/persons'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { ResponsibleAgreement },
  actions: { [ResponsibleAgreement.name]: actions },
}
